const legacyMap = {
    uk: 'en-gb',
    za: 'en-za',
};

export default legacyMap;
